import React, {useContext, useEffect} from 'react';
import * as maptalks from "maptalks";
import {mapContext} from "../context/MapcontextComponent";
import { IPointVectorLayerProps } from '../interfaces/mapInterfaces';



const PointVectorLayer = ({points, idLayer} : IPointVectorLayerProps) => {

    const {map} = useContext(mapContext)

    useEffect(()=> {
        if(map && map.options){
            map.getLayer(idLayer) && map.removeLayer(idLayer)
            let geometry = maptalks.Geometry.fromJSON((points))
            let pointVectorLayer = new maptalks.VectorLayer(idLayer, geometry)
            map.addLayer(pointVectorLayer)
        }
    }, [points, map])

    return (
        <></>
    )
}

export default PointVectorLayer
